import React from "react"
import { FixedBlockType, Form } from "sharedTypes"
import { BlockInsertPosition } from "components/Builder/BuildingBlock"
import { Box } from "@chakra-ui/react"
import { DraggableItem } from "sharedTypes/builder"
import TopFixedBlockContent from "./TopFixedBlockContent"

type Props = {
  form: Form
  rsvpConfirm: string
  rsvpDecline: string
  portalPrimaryColor: string
  editable?: boolean
  selectedFixedBlockType?: FixedBlockType
  onDropBlock?: (
    item: DraggableItem,
    blockId: number,
    position: BlockInsertPosition
  ) => void
  onSelectFixedBlockType?: (type: FixedBlockType) => void
  mergeTagEventTitle?: string
}

const TopFixedBlock = ({
  form,
  rsvpConfirm,
  rsvpDecline,
  portalPrimaryColor,
  editable,
  selectedFixedBlockType,
  onDropBlock,
  onSelectFixedBlockType,
  mergeTagEventTitle,
}: Props) => (
  <Box borderBottomWidth={1}>
    <TopFixedBlockContent
      form={form}
      rsvpConfirm={rsvpConfirm}
      rsvpDecline={rsvpDecline}
      portalPrimaryColor={portalPrimaryColor}
      editable={editable}
      selectedFixedBlockType={selectedFixedBlockType}
      onDropBlock={onDropBlock}
      onSelectFixedBlockType={onSelectFixedBlockType}
      mergeTagEventTitle={mergeTagEventTitle}
    />
  </Box>
)

export default TopFixedBlock
